import type { FC } from 'react';
import { useMemo } from 'react';
import { useQueryLocations } from '../hooks/useLocationApi';
import { Navigate } from 'react-router-dom';
import Spinner from '../components/Spinner';
import { getItemFromLocalStorage } from '@ordr-as/utils';
import { captureMessage } from '@sentry/react';

const LocationRedirect: FC = () => {
  const { data: locations, isPending, isError, error } = useQueryLocations();
  const storedLocation = useMemo(() => getItemFromLocalStorage<string>('favrit.epos.location', false), []);

  if (storedLocation) {
    return <Navigate to={`/${storedLocation}`} replace />;
  }

  if (isPending) {
    return <Spinner className="m-auto mt-6 w-8 h-8" />;
  }

  if (isError) {
    const err = error instanceof Error ? error : new Error(String(error));
    captureMessage(
      `Redirected to /locations in LocationRedirect because of location fetch error: message=${err.message} cause=${err.cause} stack=${err.stack} name=${err.name}`,
      'debug'
    );
    return <Navigate to="/locations" replace />;
  }

  if (!locations) {
    captureMessage(`Failed to fetch locations in LocationRedirect somehow`, 'debug');
    return null;
  }

  if (locations.length > 0 && locations.length < 6) {
    return <Navigate to={`/${locations[0]!.locationId}`} replace />;
  }

  return <Navigate to="/locations" replace />;
};

export default LocationRedirect;
